import types from "../types";

const actions = {
  // Add to cart
  addToCart: (product, qty, addedFromProductPage) => {
    return {
      type: types.ADD_TO_CART,
      payload: { product, qty, addedFromProductPage },
    };
  },
  // Reset Cart
  resetCart: { type: types.RESET_CART },

  removeFromCart: (product) => {
    return {
      type: types.REMOVE_FROM_CART,
      payload: product,
    };
  },
};

export default actions;
